module.exports = [{"name":"Home","icon":"home","link":"/"},{"name":"Diensten","icon":"cogs","link":"/diensten"},{"name":"Opleiding","icon":"student","link":"/opleiding"},{"name":"Klinieken","icon":"building outline","link":"/klinieken"},{"name":"JTV","icon":"history","link":"/jtv"},{"name":"FAQ","icon":"question circle","link":"faq"},{"name":"Registreer","icon":"edit","link":"/registreer"},{"name":"Vacatures","icon":"id badge","link":"/jobs"},{"name":"Contact","icon":"address card outline","link":"/contact"}]


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/MenuItems/menuItems.json
// module id = 450
// module chunks = 0